var draft = {
    title: 'SURAT PERMINTAAN KONSULTASI',
    subtitle: 'No. : ......../20',
	intro: `Kepada Yth:
	Dr Spesialisasi :`,
	p1: `Dengan Hormat,
Mohon bantuan teman sejawat atas pasien:`,
	arr1: [
		{label:'Nama Pasien',value:''},
		{label:'No. RM',value:''},
		{label:'Umur',value:''},
	],
	p2: `Untuk diberikan pelayanan Konsultasi / perawatan medis bersama untuk selanjutnya / Pengambil alih kasus untuk selanjutnya disertai dengan hasil pemeriksaan berikut ini`,
	arr2: [
		{label:'Diagnosa',value:``},
	],
	p3: `Terimakasih atas perhatiannya.`,
};
var sign = `Pekanbaru, <tgl>

Dokter Rumah Sakit



( <nama_dokter> )`;
import {
    headerImage
} from './headerImage.js';
import { labelValueFormatter } from './helper.js';
let arr1 = labelValueFormatter(draft.arr1,200);
let arr2 = labelValueFormatter(draft.arr2,200);
export const docContent = [{
        image: headerImage,
        width: 529
    },
    {
        text: draft.title,
        style: 'title'
    },
    {
        text: draft.subtitle,
        style: 'subtitle'
    },
    {
        style: 'paragraph',
        text: draft.intro
	},
	{
        style: 'paragraph',
        text: draft.p1
	},
	...arr1,
	{
        style: 'paragraph',
        text: draft.p2
	},
	...arr2,
	{
        style: 'paragraph',
        text: draft.p3
	},
	{
		columns: [
			{text:''},
			{
				style: 'sign',
				text: sign
			}
		]
	}
];

////console.log(docContent);